module.exports = __webpack_public_path__ + "img/组14@2x.070aa62e.png";